/**
 * Created by lihanying on 2017/7/6.
 */

export const GETADDCLUBINFO = 'GETADDCLUBINFO'


// WEBPACK FOOTER //
// ./src/containers/ClubAdd/constants.js